import {
  useGetUserAllowedOrganizationOfferGroups,
  useListBobcatOffers,
} from '@/api/trafikportalen';
import { useMemo } from 'react';

export const useGetCorporateStaticOffers = () => {
  const { data: allowedOfferGroups, isLoading: isLoadingOfferGroups } =
    useGetUserAllowedOrganizationOfferGroups();
  const { data: allowedOffers, isLoading: isLoadingOffers } =
    useListBobcatOffers();

  const offers = useMemo(() => {
    if (!allowedOfferGroups || !allowedOffers) return [];

    const allowedCorporateOfferGroupsIds =
      allowedOfferGroups
        ?.filter((offerGroup) => offerGroup.sales_channel === 'corporate')
        .map((offerGroup) => offerGroup.id) || [];

    const offers = allowedOffers.filter((offer) =>
      allowedCorporateOfferGroupsIds.includes(offer.bobcat_offer_group_id),
    );

    return offers;
  }, [allowedOfferGroups, allowedOffers]);

  return {
    allowedOffers: offers,
    isLoading: isLoadingOfferGroups || isLoadingOffers,
  };
};
